import { Gender } from '../../..';

export const genderMapping: { [key: string]: Gender } = {
    Female: Gender.FEMALE,
    Male: Gender.MALE,
    'Non-binary': Gender.NONBINARY,
    Transgender: Gender.TRANSGENDER,
    Intersex: Gender.INTERSEX,
    'Other non-listed': Gender.OTHER,
    'Not provided': Gender.NOTPROVIDED,
};
